export const BOOKING_FORM = "BOOKING_FORM";
export const AYANA_SESSION = "AYANA_SESSION";
export const GUEST_SERVICE_TOKEN = "GUEST_SERVICE_TOKEN";
